import styled from 'styled-components';

// ----------------------------------------------------------------------

export const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`;

export const Wrapper = styled.div<{ $chart?: boolean }>`
  min-width: 465px;
  max-width: ${(props) => props.$chart ? 'fit-content' : '600px'};
  max-height: calc(100% - 60px);
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: ${(props) => props.$chart ? '30px' : '40px'};
  position: relative;
  overflow: hidden;
  
  .pagination {
    margin-top: 0!important;
    height: 40px;
    align-items: center;
  }

  .dx-datagrid {
    margin-top: 20px;
  }
    
  ${({theme}) => theme.media.md`
    min-width: auto;
    max-width: calc(100% - 20px);
    max-height: 450px;
    padding: 20px;
  `};
`;

export const Close = styled.button`
  width: 24px;
  height: 24px;
  position: absolute;
  top: 16px;
  right: 16px;
  border-radius: 50%;
  &:hover {
    background-color: ${({theme}) => theme.colors.grayscale[100]};
  }

  svg {
    stroke: ${({theme}) => theme.colors.grayscale[500]};
  }
`;

export const Title = styled.p`
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
  text-align: left; 
  margin-bottom: 30px;
  color: ${({theme}) => theme.colors.grayscale[600]};
`;

export const Content = styled.div`
  overflow: hidden;
  max-height: calc(100vh - 170px);
  
  > div > p {
    text-align: center;
    line-height: 20px;
    color: ${({theme}) => theme.colors.grayscale[500]};
    white-space: normal;
    word-break: keep-all;

    span {
      line-height: 24px;
      font-size: 16px;
      color: ${({theme}) => theme.colors.grayscale[600]};
      font-weight: 600;
    }
  }
  
  > div > button:last-child {
    width: 100%;
  }
    
  .dx-texteditor.dx-editor-outlined {
    box-shadow: none;
    border: 1px solid #C3CAD9;
  }
`;

export const ScrollBar = styled.div`
  max-height: calc(100vh - 170px);
  overflow: overlay;

  ${({theme}) => theme.media.md`
    width: 100%;
    max-height: 356px;
  `};

  &::-webkit-scrollbar {
    width: 20px;
    height: 20px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(99, 115, 129, 0.3);
    border-radius: 10px;
    background-clip: padding-box;
    border: 8px solid transparent;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`;